<modal>
  <span header>{{'Chọn khách hàng' | lang}}</span>

  <text-filter [target]="partners" [placeholder]="'Tìm tên khách hàng'"></text-filter>  
  <table class="data hover">
    <tr>
      <th class="text-left">{{'Tên' | lang}}</th>
      <th class="text-right">{{'Mã' | lang}}</th>
    </tr>
    <tr *ngFor="let i of partners.matches" class="pointer" (click)="select(i)">
      <td>{{i.Name}}</td>
      <td class="text-primary spacy text-right">K{{i.ID}}</td>
    </tr>
    
  </table>
</modal>
